import { SB } from '@play-co/replicant';

export const rescueLevelSchema = {
  rescueLevel: SB.object({
    /** Rescue sequence activated by the newest delivered rescue OA */
    activeBucket: SB.string().optional(),
    /** Match-2 levels completed in the current or most recent rescue sequence */
    playedLevels: SB.array(SB.number()).optional(),
  }).optional(),
};
